<template>
  <div v-if="loading_page"></div>
  <div v-else id="invoice-POS">
    <center id="top" style="margin-bottom: 10px;">
      <div class="logo">
        <img :src="img_arin" alt="" style="max-width: 150px;">
      </div>
      <div class="info w-100" style="margin-bottom: 10px;">
        <div class="font-13"> {{ seller.status_main_store == 1 ? 'บริษัท ฟาร์มาแคร์ พลัส จำกัด' : seller.store_name }}
        </div>
        <div class="font-13">TAX#{{ seller.store_personal_id }} (VAT Includ)</div>
        <div class="font-13">เลขที่ 55/5 ห้อง 309 หมู่ 3 ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่</div>
        <!-- <div class="font-13">ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ</div> -->
         {{ seller }}
        <div class="font-13">POS ID E085000002A0062</div>
        <!-- <div class="font-13">เบอร์โทร {{ seller.tel }}</div> -->
      </div><!--End Info-->
    </center>
    <!--End InvoiceTop-->
    <!-- <br /> -->
    <center id="top">
      <div class="info w-100" style="margin-bottom: 10px;">
        <div class="font-16 fw-500">รหัสเครื่อง KAT B</div>
        <div class="font-16 fw-500">เลที่เอกสาร B-06230121-001</div>
        <div class="font-16 fw-500">วันที่ 08/03/2023 10:02:00</div>
        <!-- <div class="font-13">ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ</div> -->
        <div class="font-16 fw-500">แคชเชียร์ KAT แคทลิยา</div>
        <!-- <div class="font-13">เบอร์โทร {{ seller.tel }}</div> -->
      </div><!--End Info-->
    </center>
    <!--End InvoiceTop-->

    <v-row style="margin-top: 2px !important;">
      <v-col cols="6">
        <div class="font-16 fw-500">SIGN-IN 10:02</div>
      </v-col>
      <v-col cols="6">
        <div class="font-16 fw-500 text-right">SIGN-OUT 20:52</div>
      </v-col>
    </v-row>
    <tr>
      <td>
        <h1 class="font-16 fw-600" style="margin-left: 13px;">สรุปยอดขาย :</h1>
      </td>
    </tr>

    <div id="bot">
      <div id="table">
        <table>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">ยอดขาย</p>
            </td>
            <td></td>
            <td>
              <!-- <p class="mt-5 font-12">{{total_qty}} ชิ้น</p> -->
            </td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.total_amount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">ส่วนลด</p>
            </td>
            <td></td>
            <td>
              <p class="mt-5 font-13"></p>
            </td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.discount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">ยอดขายหักส่วนลด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.total_amount_after_discount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">ภาษี 7%</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.vat) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">ยอดขายสุทธิ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">4{{ formatPrice(get_data.total_amount_after_vat) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h1 class="font-16 fw-600" style="margin-left: 13px;">สรุปการรับเงินจากการขาย :</h1>
            </td>
          </tr>


          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.cash) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เงินโอน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.payment) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">qr payment</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.qrcode_pay) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.credit) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">อื่นๆ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.etc_payment) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">แต้มแทนเงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.use_point) }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">รวมรับเงินทั้งสิ้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.total_pay) }}</p>
            </td>
          </tr>


          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h1 class="font-16 fw-600" style="margin-left: 13px;">สรุปการรับเงินจากเครดิตการ์ด :</h1>
            </td>
          </tr>


          <tr v-for="(item, i) in get_data.credit_card" :key="i" class="tabletitle">
            <td>
              <p class="mt-5 font-13">{{item.card_name_eng}}</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{formatPrice(item.total)}}</p>
            </td>
          </tr>
          <!-- <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">KTB</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">1,593.50</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">KTB</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">1,593.50</p>
            </td>
          </tr> -->
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เครดิตชาร์จ (Credit Charge)</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.credit_charge) }}</p>
            </td>
          </tr>



          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h1 class="font-16 fw-600" style="margin-left: 13px;">สรุปยอดเงินสดในลิ้นชัก :</h1>
            </td>
          </tr>


          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เงินทอน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.init_money_amount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">รับจากการขาย</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.total_cash) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">ส่วนต่าง ณ ตอนปิดรอบ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.diff_total_cash) }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เงินคงเหลือในลิ้นชัก</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.total_cash_net) }}</p>
            </td>
          </tr>

          <!-- <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>
          <h1 class="font-16 fw-600" style="margin-left: 13px;">สรุปยอดส่งเงิน :</h1>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">1,593.50</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">คูปอง</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">รวมมูลค่านำส่ง</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr> -->

          <!-- <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>
          <h1 class="font-16 fw-600" style="margin-left: 13px;">สรุปยอดเงินคงเหลือในลิ้นชัก :</h1>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">1,593.50</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">คูปอง</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr> -->

          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h1 class="font-16 fw-600" style="margin-left: 13px;">เลขที่ใบเสร็จ :</h1>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เลขที่ใบเสร็จเริ่มต้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ get_data.first_invoice }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เลขที่ใบเสร็จสุดท้าย</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ get_data.last_invoice }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">จำนวนบิลขายทั้งหมด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ get_data.count_bill }}</p>
            </td>
          </tr>
          <!-- <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">จำนวนบิลขายสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">จำนวนบิลขายเชื่อ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr> -->
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เฉลี่ยขายต่อบิล</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">{{ formatPrice(get_data.avg_total) }}</p>
            </td>
          </tr>
          <!-- <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เลขที่ใบรับคืนเริ่มต้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-13">เลขที่ใบรับคืนสุดท้าย</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-12">0.00</p>
            </td>
          </tr> -->
          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>


          <!-- <tr>
            <td colspan="4">
              <div class=" font-13 "> ข้อมูลสมาชิก {{ detailList.invoice.member_name }} </div>
            </td>
          </tr>
          <br>
          <tr>
            <td class="item"></td>
            <td>
              <p class="font-13 text-center">ได้รับ</p>
            </td>
            <td>
              <p class="font-13 text-center">ใช้ไป</p>
            </td>
            <td>
              <p class="font-13 text-center">คงเหลือ</p>
            </td>
          </tr>

          <tr>
            <td>
              <p class="font-13 mt-5">แต้มสมาชิก</p>
            </td>
            <td>
              <p class="font-12 text-center mt-5">+{{ detailList.invoice.member_name == null ? formatPrice(0) :
                formatPrice(detailList.invoice.point) }}</p>
            </td>
            <td>
              <p class="font-12 text-center mt-5">{{ formatPrice(detailList.invoice.use_point) }}</p>
            </td>
            <td>
              <p class="font-12 text-center mt-5">{{ formatPrice(detailList.invoice.point_remain) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray-mid font-10 mt-4 "> ** ยอดใช้ไปและยอดคงเหลือ ไม่รวมยอดสะสมครั้งนี้ ** </div>
            </td>
          </tr> -->

        </table>
      </div><!--End Table-->

      <div id="legalcopy">
        <p class="font-16 fw-500">แคชเชียร์ :</p>
      </div>
    </div><!--End InvoiceBot-->
  </div><!--End Invoice-->
</template>

<script>
import img_arin from "@/assets/arin_assets/pharmacare-black.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  data() {
    return {
      img_arin: img_arin,
      items: [
        { name: "tab.CARATEN 12.5 MG. ...", sale: "ส่วนลด NODOGLE SPRAY ", quantity: 5, subTotal: 375, slae_cost: 80 },
        // { name: "eent.NODOGLE SPRAY   ...",sale: null, quantity: 3, subTotal: 225 , slae_cost: 0},
        // { name: "ยาดม IZE JELLI BALM 7  ...",sale: null, quantity: 5, subTotal: 375 , slae_cost: 0},
        // { name: "cr.DELANIN CREAM 5G ...",sale: null, quantity: 20, subTotal: 1500 , slae_cost: 0},

      ],
      value: 295,
      sale_sum: 20,
      tax: 19.25,
      credit: 8.83,
      total: 303.08,
      cash: 310.00,
      change: 6.92,
      get_data: {},
      total_qty: 0,
      total_price: 0,
      seller: {},
      loading_page: true,
      vowelCharacters: "aeiouAEIOUะัาำิีึื็ุู่้๊๋์ํๆ"
    };
  },
  methods: {
    truncateString(product_name) {
      var maxLength = 15;
      var truncatedString = '';
      var characterCount = 0;

      for (var i = 0; i < product_name.length; i++) {
        var character = product_name[i];
        truncatedString += character;

        if (this.vowelCharacters.indexOf(character) === -1) {
          characterCount++;
        }

        if (characterCount >= maxLength) {
          break;
        }
      }

      if (product_name.length > maxLength) {
        truncatedString += "...";
      }

      product_name = truncatedString;
      return product_name
    },
    formatPrice(value) {
      return formatPrice(value);
    },
    async print() {
      document.getElementById("invoice-POS").innerHTML;
      // document.body.innerHTML = printContents;
      const originalContents = document.body.innerHTML;
      window.print();


      window.onafterprint = function () {
        document.body.innerHTML = originalContents;
        window.close();
      };
    },
    // async getReceipt() {
    //   this.loading_page = true;
    //   let config = {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
    //     }
    //   }
    //   let id = this.$route.query.id
    //   await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
    //     if (res.data.successful === true) {
    //       this.detailList = res.data.data
    //       this.detailList.invoice_list.forEach((detail) => {
    //         if (detail.product_code != null) {
    //           this.total_qty += parseFloat(detail.qty)
    //           this.total_price += parseFloat(detail.total)
    //         } else {
    //           this.total_price -= parseFloat(detail.total)
    //         }
    //       })
    //       this.loading_page = false;
    //       this.getSotre()
    //     }
    //   })
    // },
    // async getSotre() {
    //   let config = {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
    //     }
    //   }
    //   let store_id = this.$store.state.store_arin.user_data.store_id;
    //   await HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
    //     if (res.data.successful === true) {
    //       this.seller = res.data.storeDetail;
    //     }
    //   })
    //   this.print()
    // },
    
    // api/pos/report/round/print
    async getRoundPrint() {
      this.loading_page = true;
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      }
      let id = parseInt(this.$route.query.id);
      let round_print_type = parseInt(this.$route.query.type);

      // ดึงทั้งหมด
      if(round_print_type == 0){
        await HTTP_ARIN.post(`/pos/report/round/print/pdf`,{id: id, type: round_print_type}, config).then((res) => {
          if (res.data.successful === true) {
            this.get_data = res.data.data
            this.loading_page = false;
          }
        })
      }else if(round_print_type == 1){
        let invoice_id =JSON.parse( window.localStorage.getItem("sum_data"));
        await HTTP_ARIN.post(`/pos/report/round/print/pdf`,{id: id, type: round_print_type, invoice_id: invoice_id}, config).then((res) => {
          if (res.data.successful === true) {
            this.get_data = res.data.data
            this.loading_page = false;
          }
        })
      }

    }
  },
  mounted() {
    // this.getReceipt()
    this.getRoundPrint()

  },
};
</script>

<style scoped>
.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.font-8 {
  font-size: 8px;
}

.font-10 {
  font-size: 10px;
}

.font-11 {
  font-size: 11px;
}

.font-12 {
  font-size: 11.5px;
}

.font-13 {
  font-size: 11.5px;
}

.font-14 {
  font-size: 14px;
}

.font-16 {
  font-size: 16px;
}

#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 80mm;
  background: #FFF;
}

::selection {
  background: #f31544;
  color: #FFF;
}

::moz-selection {
  background: #f31544;
  color: #FFF;
}

h1 {
  font-size: 1.5em;
  color: #000000;
}

h2 {
  font-size: 0.9em;
}

h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}

p {
  font-size: 1em;
  color: #000000;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #EEE;
}

#top {
  min-height: 100px;
}

#mid {
  min-height: 80px;
}

#bot {
  min-height: 50px;
}

#top .logo {
  /*float: left;*/
  /* height: 60px; */
  width: 150px;
  /* background: url('img_arin') no-repeat; */
  background-size: 60px 60px;
}

.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}

.info {
  display: block;
  /*float:left;*/
  margin-left: 0;
}

.title {
  float: right;
}

.title p {
  text-align: right;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td p {
  font-size: 0.9em;
  /*padding: 5px 0 5px 15px;*/
  /*border: 1px solid #EEE*/
}

.tabletitle {
  /*padding: 5px;*/
  font-size: 0.6em;
  /* background: #EEE; */
}

.service {
  border-bottom: 0px solid #EEE;
}

.item {
  width: 40mm;
}

.item-med {
  width: 15mm;
}

.itemtext {
  font-size: 0.9em;
}

.Rate {
  font-size: 0.9em;
}

.payment {
  font-size: 1.2em;
}

#legalcopy {
  margin-top: 7mm;
  margin-bottom: 7mm;
}

.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pr-5 {
  padding-right: 5px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.w-100 {
  width: 100%;
}

.color-gray {
  color: #000000;
}

.color-gray-mid {
  color: #000000;
}

.va-top {
  vertical-align: top;
}

.mt-10 {
  margin-top: 10px;
}

.mt-5 {
  margin-top: 7px;
}

.mt-4 {
  margin-top: 4px;
}
</style>


